import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Ranking from "./pages/Ranking";
import Missions from "./pages/Missions";
import Achievements from "./pages/Achievements";
import Admin from "./pages/Admin";
import Store from "./pages/Store";
import BottomNav from "./components/BottomNav";
import NewSaleSheet from "./components/NewSaleSheet";
import "./App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="arcade-grid min-h-screen flex items-center justify-center">
        <div className="font-arcade text-fuchsia-400 text-xl">Carregando...</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function Shell() {
  const { user, refresh } = useAuth();
  const [showSale, setShowSale] = useState(false);

  if (user === null) {
    return (
      <div className="arcade-grid min-h-screen flex items-center justify-center">
        <div className="font-arcade text-fuchsia-400 text-xl">Carregando...</div>
      </div>
    );
  }
  if (user === false) return <Login />;

  return (
    <>
      <Routes>
        <Route path="/" element={<Dashboard onNewSale={() => setShowSale(true)} />} />
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/missoes" element={<Missions />} />
        <Route path="/conquistas" element={<Achievements />} />
        <Route path="/loja" element={user.role === "admin" ? <Navigate to="/admin" replace /> : <Store />} />
        <Route path="/admin" element={user.role === "admin" ? <Admin /> : <Navigate to="/" replace />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <BottomNav onNewSale={() => setShowSale(true)} />
      <NewSaleSheet
        open={showSale}
        onClose={() => setShowSale(false)}
        onCreated={() => refresh()}
      />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" theme="dark" richColors />
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}
